function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { ButtonWithIcon, Button } from '@els/els-react--button';
import { Icon } from '@els/els-react--icon';
import { createEnum, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var BannerTypes = createEnum(['info', 'confirm', 'warn', 'alert']);
var BannerSizes = createEnum(['default', 'small']);
var DefaultMessages = createEnum({
  closeButton: 'Close',
  colon: ':',
  confirm: 'Confirm',
  warn: 'Warn',
  alert: 'Alert',
  default: 'Information'
});
var bool = PT.bool,
  func = PT.func,
  node = PT.node,
  object = PT.object,
  oneOf = PT.oneOf,
  string = PT.string;
var defaults = {
  children: null,
  className: "",
  hideCloseLabel: false,
  id: null,
  icon: null,
  isFilled: false,
  isIconVisible: true,
  link: null,
  messages: DefaultMessages,
  onClose: null,
  type: BannerTypes.INFO,
  size: BannerSizes.DEFAULT,
  onDark: false
};
var Banner = function Banner(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? defaults.children : _ref$children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    _ref$hideCloseLabel = _ref.hideCloseLabel,
    hideCloseLabel = _ref$hideCloseLabel === void 0 ? defaults.hideCloseLabel : _ref$hideCloseLabel,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? defaults.icon : _ref$icon,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? defaults.isFilled : _ref$isFilled,
    _ref$isIconVisible = _ref.isIconVisible,
    isIconVisible = _ref$isIconVisible === void 0 ? defaults.isIconVisible : _ref$isIconVisible,
    isVisible = _ref.isVisible,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? defaults.link : _ref$link,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? defaults.messages : _ref$messages,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? defaults.onClose : _ref$onClose,
    _ref$onDark = _ref.onDark,
    onDark = _ref$onDark === void 0 ? defaults.onDark : _ref$onDark,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaults.size : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? defaults.type : _ref$type;
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  if (!BannerTypes.getAll().includes(type)) {
    throw new TypeError("The type property must be one of ".concat(BannerTypes.getAll().join(", ")));
  }
  if (!children) {
    throw new TypeError("Banner must have children");
  }
  var baseClassName = "c-els-banner";
  var bannerClasses = classnames(baseClassName, "".concat(baseClassName, "--").concat(type), className, {
    "c-els-banner--fill": isFilled,
    "c-els-banner--small": size === BannerSizes.SMALL,
    "c-els-banner--on-dark": onDark
  });
  var getIconSprite = function getIconSprite() {
    var fallbackIcon;
    switch (type) {
      case BannerTypes.CONFIRM:
        fallbackIcon = Icon.Sprites.CONFIRMATION_OUTLINE_CIRCLE;
        break;
      case BannerTypes.WARN:
        fallbackIcon = Icon.Sprites.ALERT_OUTLINE_SQUARE;
        break;
      case BannerTypes.ALERT:
        fallbackIcon = Icon.Sprites.ALERT;
        break;
      default:
        fallbackIcon = Icon.Sprites.INFORMATION_OUTLINE_CIRCLE;
        break;
    }
    return icon || fallbackIcon;
  };
  var getIconName = function getIconName() {
    var fallbackIcon;
    switch (type) {
      case BannerTypes.CONFIRM:
        fallbackIcon = compiledMessages.CONFIRM;
        break;
      case BannerTypes.WARN:
        fallbackIcon = compiledMessages.WARN;
        break;
      case BannerTypes.ALERT:
        fallbackIcon = compiledMessages.ALERT;
        break;
      default:
        fallbackIcon = compiledMessages.DEFAULT;
        break;
    }
    return icon || fallbackIcon;
  };
  return isVisible && /* @__PURE__ */React.createElement("div", {
    id: id,
    className: bannerClasses,
    "data-testid": "banner"
  }, isIconVisible && /* @__PURE__ */React.createElement("div", {
    className: "".concat(baseClassName, "__icon"),
    "data-testid": "banner-icon"
  }, /* @__PURE__ */React.createElement(Icon, {
    sprite: getIconSprite(),
    size: size === BannerSizes.SMALL ? "xs" : "s",
    textAlignment: "top",
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "".concat(type.charAt(0).toUpperCase()).concat(type.slice(1), ":");
    })
  }, "".concat(getIconName()).concat(compiledMessages.COLON))), /* @__PURE__ */React.createElement("div", {
    className: "c-els-banner__message",
    "data-testid": "banner-message"
  }, children), link && /* @__PURE__ */React.createElement("div", {
    className: "c-els-banner__link",
    "data-testid": "banner-link"
  }, link), onClose && /* @__PURE__ */React.createElement("div", {
    className: "c-els-banner__close-button"
  }, /* @__PURE__ */React.createElement(ButtonWithIcon, {
    id: id ? "".concat(id, "-close-button") : null,
    type: Button.Types.LINK,
    onClick: onClose,
    "data-testid": "banner-close-button",
    sprite: Icon.Sprites.CLOSE,
    iconRight: true,
    linkIconSize: "s",
    className: "c-els-banner__close-icon",
    iconOnly: hideCloseLabel,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "x";
    })
  }, compiledMessages.CLOSE_BUTTON)));
};
Banner.propTypes = {
  /** content shown in Banner */
  children: node,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** Hide the label on the close icon (show by default) */
  hideCloseLabel: bool,
  /** To render custom Icon */
  icon: oneOf(Object.values(Icon.Sprites)),
  /** Banner ID */
  id: string,
  /** Original "notification-banner" styling, still supported */
  isFilled: bool,
  /** Visibility of Icon */
  isIconVisible: bool,
  /** Visibility of Banner */
  isVisible: bool.isRequired,
  /** JSX link, using whatever linking component/markup the application requires */
  link: node,
  /** Messages for internationalization */
  messages: object,
  /** Defines size of Banner */
  size: oneOf(BannerSizes.getAll()),
  /** Defines type of Icon */
  type: oneOf(BannerTypes.getAll()),
  /** Function triggered on clicking the close button */
  onClose: func,
  /** Dark mode state */
  onDark: bool
};
Banner.requiredProps = {
  isVisible: ValidPropTypes.BOOL
};
Banner.Sizes = BannerSizes;
Banner.Types = BannerTypes;
Banner.defaults = defaults;
Banner.DefaultMessages = DefaultMessages;
var RawBanner = Banner;
var Banner$1 = makeErrorBoundComponent(RawBanner);
export { Banner$1 as Banner, RawBanner };
